(function () {
  'use strict';

  if (window.kovaliPayPalPackageSync) return;
  window.kovaliPayPalPackageSync = true;

  var messageSelector = '[data-kovali-paypal-base-amount]';
  var products = new Map();
  var boundWidgets = new WeakSet();
  var renderedMessages = new WeakSet();

  function renderNewMessage(message) {
    var sdk = window.paypal;
    if (!sdk || typeof sdk.Messages !== 'function' || message.querySelector('iframe') || renderedMessages.has(message)) return;

    renderedMessages.add(message);
    try {
      // Preserve all existing style/text options from the data-pp-* attributes.
      Promise.resolve(sdk.Messages().render(message)).catch(function () {
        renderedMessages.delete(message);
      });
    } catch (error) {
      renderedMessages.delete(message);
    }
  }

  function updateProduct(root) {
    if (!root.isConnected) return;

    var widget = Array.from(root.querySelectorAll('kaching-bundles-block')).find(function (element) {
      return element.closest('product-info') === root;
    });
    var total = null;

    if (widget) {
      if (!boundWidgets.has(widget)) {
        boundWidgets.add(widget);
        ['items-changed', 'variants-changed', 'variant-selected', 'deal-bar-selected'].forEach(function (name) {
          widget.addEventListener(name, function () { schedule(root); });
        });
      }
      try {
        var pricing = typeof widget.pricing === 'function' ? widget.pricing() : null;
        var amount = pricing && pricing.discountedPrice && pricing.discountedPrice.amount;
        // Kaching returns the full package total in euros, not Shopify cents.
        if (typeof amount === 'number' && Number.isFinite(amount) && amount > 0) total = amount;
      } catch (error) {
        // During widget initialization/replacement, retain the variant fallback.
      }
    }

    root.querySelectorAll(messageSelector).forEach(function (message) {
      if (message.closest('product-info') !== root) return;
      var amount = total === null ? Number.parseFloat(message.getAttribute('data-kovali-paypal-base-amount')) : total;
      if (!Number.isFinite(amount) || amount <= 0) return;

      var value = amount.toFixed(2);
      if (message.getAttribute('data-pp-amount') !== value) {
        // The SDK observes this attribute; existing messages/modal stay intact.
        message.setAttribute('data-pp-amount', value);
      }
      // Broadcast replaces the price block on variant changes. Render new nodes only.
      renderNewMessage(message);
    });
  }

  function schedule(root) {
    var state = products.get(root);
    if (!state) return;
    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(function () { updateProduct(root); }, 120);
  }

  function watchProduct(root) {
    if (!products.has(root)) {
      var observer = new MutationObserver(function (records) {
        if (records.some(function (record) {
          var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          return !target || !target.closest('[data-pp-message]');
        })) schedule(root);
      });
      var onChange = function () { schedule(root); };
      products.set(root, { observer: observer, timer: null, onChange: onChange });
      observer.observe(root, { childList: true, subtree: true });
      root.addEventListener('change', onChange);
    }
    schedule(root);
  }

  function stopWatching(root, state) {
    state.observer.disconnect();
    window.clearTimeout(state.timer);
    root.removeEventListener('change', state.onChange);
    products.delete(root);
  }

  function scanProducts() {
    products.forEach(function (state, root) {
      if (!root.isConnected) stopWatching(root, state);
    });
    document.querySelectorAll(messageSelector).forEach(function (message) {
      var root = message.closest('product-info');
      if (root) watchProduct(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanProducts, { once: true });
  } else {
    scanProducts();
  }

  document.addEventListener('theme:product-info:loaded', scanProducts);
  document.addEventListener('shopify:section:load', scanProducts);
  document.addEventListener('kaching-bundles-block-loaded', scanProducts);
  document.addEventListener('shopify:section:unload', function (event) {
    products.forEach(function (state, root) {
      if (event.target === root || event.target.contains(root)) stopWatching(root, state);
    });
  });

  if (window.customElements) {
    window.customElements.whenDefined('kaching-bundles-block').then(scanProducts);
  }
  var sdkScript = document.querySelector('script[src*="paypal.com/sdk/js"]');
  if (sdkScript) sdkScript.addEventListener('load', scanProducts, { once: true });
})();
